import { useMutation } from '@tanstack/react-query';
import { api } from '@/shared/axios-client';

export interface GithubInstrumentationBody {
  github_org: string;
  repo_url: string;
  target_branch: string;
  reviewers: string[];
  /** Optional Actions workflow id/name/filename; auto-detected when omitted */
  workflow_name?: string;
  /** Mongo repositories._id for the app repo */
  repo_id?: string;
  /** Where to store PR status on the app repo document */
  instrumentation_target?: 'app' | 'test';
}

export interface GithubInstrumentationResponse {
  job_id: string;
  status: string;
  message?: string;
}

export const postGithubInstrumentation = (
  body: GithubInstrumentationBody,
  patToken: string,
): Promise<GithubInstrumentationResponse> =>
  api.post('/api/github/instrumentation/async', body, {
    headers: {
      'Requester-Token': patToken,
      'Content-Type': 'application/json',
    },
  });

export const usePostGithubInstrumentation = (patToken: string) =>
  useMutation({
    mutationFn: (body: GithubInstrumentationBody) =>
      postGithubInstrumentation(body, patToken),
  });
